<template>
    <div class="bd">
        <div class="my-custom-table">
            <a-tabs v-model:activeKey="activeTab" @change="onTabChange" class="tab-container">
                <a-tab-pane key="industry" tab="行业">
                    <div class="search-bar">
                        <div class="tabInput">
                            <a>行业名称：</a>
                            <a-input v-model:value="searchText" placeholder="请输入行业名称进行搜索" class="search-input" />
                        </div>
                        <div class="tab-button">
                            <div>
                                <a-button class="search-tow" type="primary" @click="onSearch" :icon="h(SearchOutlined)">搜索</a-button>
                                <a-button class="search-tow" @click="onReset" :icon="h(RedoOutlined)">重置</a-button>
                            </div>
                            <div class="right-option">
                                <a-button type="primary" @click="toAdd" :icon="h(PlusCircleOutlined)">添加</a-button>
                            </div>
                        </div>
                    </div>
                    <a-table :columns="columns" :data-source="data" :pagination="pagination" row-key="id" :scroll="{ y: 'calc(100vh - 360px)' }" class="flex-table">
                        <template #bodyCell="{ column, record }">
                            <template v-if="column.key === 'status'">
                                <a-tag v-if="record.status === '正常'" color="green">{{ record.status }}</a-tag>
                                <a-tag v-else color="red">{{ record.status }}</a-tag>
                            </template>
                            <template v-if="column.dataIndex === 'operation'">
                                <div class="editable-row-operations">
                                    <a @click="edit(record)">查看</a>
                                    <a-divider type="vertical" />
                                    <a-popconfirm title="确认删除？" ok-text="是" cancel-text="否" @confirm="remove(record.id)">
                                        <a style="margin: 15px;">删除</a>
                                    </a-popconfirm>
                                </div>
                            </template>
                        </template>
                    </a-table>
                </a-tab-pane>
                <a-tab-pane key="taxType" tab="税种">
                    <div class="search-bar">
                        <div class="tabInput">
                            <a>税种名称：</a>
                            <a-input v-model:value="searchText" placeholder="请输入税种名称进行搜索" class="search-input" />
                        </div>
                        <div class="tab-button">
                            <div>
                                <a-button class="search-tow" type="primary" @click="onSearch" :icon="h(SearchOutlined)">搜索</a-button>
                                <a-button class="search-tow" @click="onReset" :icon="h(RedoOutlined)">重置</a-button>
                            </div>
                            <div class="right-option">
                                <a-button type="primary" @click="toAdd" :icon="h(PlusCircleOutlined)">添加</a-button>
                            </div>
                        </div>
                    </div>
                    <a-table :columns="columns" :data-source="data" :pagination="pagination" row-key="id" :scroll="{ y: 'calc(100vh - 360px)' }" class="flex-table">
                        <template #bodyCell="{ column, record }">
                            <template v-if="column.key === 'status'">
                                <a-tag v-if="record.status === '正常'" color="green">{{ record.status }}</a-tag>
                                <a-tag v-else color="red">{{ record.status }}</a-tag>
                            </template>
                            <template v-if="column.dataIndex === 'operation'">
                                <div class="editable-row-operations">
                                    <a @click="edit(record)">查看</a>
                                    <a-divider type="vertical" />
                                    <a-popconfirm title="确认删除？" ok-text="是" cancel-text="否" @confirm="remove(record.id)">
                                        <a style="margin: 15px;">删除</a>
                                    </a-popconfirm>
                                </div>
                            </template>
                        </template>
                    </a-table>
                </a-tab-pane>
                <a-tab-pane key="taxKeyword" tab="涉税关键词">
                    <div class="search-bar">
                        <div class="tabInput">
                            <a>关键词：</a>
                            <a-input v-model:value="searchText" placeholder="请输入涉税关键词进行搜索" class="search-input" />
                        </div>
                        <div class="tab-button">
                            <div>
                                <a-button class="search-tow" type="primary" @click="onSearch" :icon="h(SearchOutlined)">搜索</a-button>
                                <a-button class="search-tow" @click="onReset" :icon="h(RedoOutlined)">重置</a-button>
                            </div>
                            <div class="right-option">
                                <a-button type="primary" @click="toAdd" :icon="h(PlusCircleOutlined)">添加</a-button>
                            </div>
                        </div>
                    </div>
                    <a-table :columns="columns" :data-source="data" :pagination="pagination" row-key="id" :scroll="{ y: 'calc(100vh - 360px)' }" class="flex-table">
                        <template #bodyCell="{ column, record }">
                            <template v-if="column.key === 'status'">
                                <a-tag v-if="record.status === '正常'" color="green">{{ record.status }}</a-tag>
                                <a-tag v-else color="red">{{ record.status }}</a-tag>
                            </template>
                            <template v-if="column.dataIndex === 'operation'">
                                <div class="editable-row-operations">
                                    <a @click="edit(record)">查看</a>
                                    <a-divider type="vertical" />
                                    <a-popconfirm title="确认删除？" ok-text="是" cancel-text="否" @confirm="remove(record.id)">
                                        <a style="margin: 15px;">删除</a>
                                    </a-popconfirm>
                                </div>
                            </template>
                        </template>
                    </a-table>
                </a-tab-pane>
            </a-tabs>
            <addComponent ref="childOpen" :tabKey="activeTab" @saved="onSaved" />
        </div>
    </div>
</template>

<script>
import {
    industryPage, removeIndustry,
    taxTypePage, removeTaxType,
    taxKeywordPage, removeTaxKeyword
} from '@/api/service';
import { cloneDeep } from 'lodash-es';
import { message } from 'ant-design-vue';
import { SearchOutlined, RedoOutlined, PlusCircleOutlined } from '@ant-design/icons-vue';
import { ref, h, computed } from 'vue';
import addComponent from './modal/addComponent.vue';

export default {
    name: 'CodePage',
    components: {
        addComponent
    },
    setup() {
        const data = ref([]);
        const searchText = ref('');
        const activeTab = ref('industry');
        const childOpen = ref(null);
        const pagination = ref({
            current: 1,
            pageSize: 10,
            total: 0,
            showSizeChanger: true,
            showQuickJumper: true,
            onChange: (page, pageSize) => {
                pagination.value.current = page;
                pagination.value.pageSize = pageSize;
                list();
            },
            position: ['bottomLeft']
        });

        const tabConfig = {
            industry: {
                pageApi: industryPage,
                removeApi: removeIndustry,
                searchField: 'name',
                columns: [
                    { title: '行业编码', dataIndex: 'code', key: 'code', width: '15%' },
                    { title: '行业名称', dataIndex: 'name', key: 'name', width: '20%' },
                    { title: '排序', dataIndex: 'sort', key: 'sort', width: '8%' },
                    { title: '状态', dataIndex: 'status', key: 'status', width: '8%' },
                    { title: '创建人', dataIndex: 'createBy', key: 'createBy', width: '10%' },
                    { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt', width: '12%' },
                    { title: '操作', dataIndex: 'operation', width: '10%' },
                ],
                mapItem: (item) => ({
                    id: item.id,
                    code: item.code,
                    name: item.name,
                    sort: item.sort,
                    status: item.status,
                    createBy: item.createBy,
                    createdAt: item.createdAt,
                })
            },
            taxType: {
                pageApi: taxTypePage,
                removeApi: removeTaxType,
                searchField: 'name',
                columns: [
                    { title: '税种编码', dataIndex: 'code', key: 'code', width: '15%' },
                    { title: '税种名称', dataIndex: 'name', key: 'name', width: '20%' },
                    { title: '排序', dataIndex: 'sort', key: 'sort', width: '8%' },
                    { title: '状态', dataIndex: 'status', key: 'status', width: '8%' },
                    { title: '创建人', dataIndex: 'createBy', key: 'createBy', width: '10%' },
                    { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt', width: '12%' },
                    { title: '操作', dataIndex: 'operation', width: '10%' },
                ],
                mapItem: (item) => ({
                    id: item.id,
                    code: item.code,
                    name: item.name,
                    sort: item.sort,
                    status: item.status,
                    createBy: item.createBy,
                    createdAt: item.createdAt,
                })
            },
            taxKeyword: {
                pageApi: taxKeywordPage,
                removeApi: removeTaxKeyword,
                searchField: 'keyword',
                columns: [
                    { title: '涉税关键词', dataIndex: 'keyword', key: 'keyword', width: '18%' },
                    { title: '关键词描述', dataIndex: 'description', key: 'description', width: '22%' },
                    { title: '排序', dataIndex: 'sort', key: 'sort', width: '8%' },
                    { title: '状态', dataIndex: 'status', key: 'status', width: '8%' },
                    { title: '创建人', dataIndex: 'createBy', key: 'createBy', width: '10%' },
                    { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt', width: '12%' },
                    { title: '操作', dataIndex: 'operation', width: '10%' },
                ],
                mapItem: (item) => ({
                    id: item.id,
                    keyword: item.keyword,
                    description: item.description,
                    sort: item.sort,
                    status: item.status,
                    createBy: item.createBy,
                    createdAt: item.createdAt,
                })
            }
        };

        const columns = computed(() => {
            return tabConfig[activeTab.value]?.columns || [];
        });

        const list = async () => {
            const config = tabConfig[activeTab.value];
            if (!config) return;
            const params = {
                pageNumber: pagination.value.current,
                pageSize: pagination.value.pageSize,
            };
            params[config.searchField] = searchText.value || undefined;
            const response = await config.pageApi(params);
            if (response.code === 200) {
                pagination.value.total = response.totalRow || response.data?.totalRow || response.data?.total || 0;
                data.value = (response.data.records || []).map(config.mapItem);
            }
        };

        list();

        const onTabChange = () => {
            searchText.value = '';
            pagination.value.current = 1;
            list();
        };

        const deleteItem = async (id) => {
            const config = tabConfig[activeTab.value];
            if (!config) return false;
            const response = await config.removeApi(id);
            if (response.code === 200) {
                message.success('删除成功');
                return true;
            } else {
                message.error('删除失败' + response.msg);
                return false;
            }
        };

        const remove = async (id) => {
            const success = await deleteItem(id);
            if (success) {
                data.value = cloneDeep(data.value.filter(item => id != item.id));
            }
        };

        const edit = (record) => {
            childOpen.value.openEdit(record);
        };

        const onSearch = () => {
            pagination.value.current = 1;
            list();
        };

        const onReset = () => {
            searchText.value = '';
            list();
        };

        const toAdd = () => {
            childOpen.value.open = true;
        };

        const onSaved = () => {
            list();
        };

        return {
            columns,
            pagination,
            data,
            searchText,
            activeTab,
            childOpen,
            SearchOutlined,
            RedoOutlined,
            PlusCircleOutlined,
            onSearch,
            onReset,
            toAdd,
            onTabChange,
            onSaved,
            h,
            remove,
            edit,
        };
    },
};
</script>
<style scoped>
.tab-container {
    margin: 10px
}
.my-custom-table {
    display: flex;
    flex-direction: column;
}
.my-custom-table :deep(.ant-tabs) {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
}
.my-custom-table :deep(.ant-tabs-content-holder) {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
}
.my-custom-table :deep(.ant-tabs-content) {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
}
.my-custom-table :deep(.ant-tabs-tabpane) {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
}
.my-custom-table :deep(.ant-table-wrapper) {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
}
</style>
